(ns assemble.assets-page.upload-modal.view
  (:require ["react-dropzone-new" :refer [useDropzone]]
            ["react-use/lib/useBeforeUnload$default" :as useBeforeUnload]
            ["react-use/lib/useMeasure$default" :as useMeasure]
            [assemble.assets-page.upload-modal.db :as db]
            [assemble.assets-page.upload-modal.fonts :as fonts]
            [assemble.component.upload-modal :as upload-modal]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(def action-column
  (upload-modal/create-action-column
   {:on-retry (fn [_e ^js o] (rf/dispatch [:assemble.resource.asset/retry-upload (:id (.-row o))]))
    :on-delete (fn [_e ^js o] (rf/dispatch [::db/remove-queue-item (:id (.-row o))]))}))

(def columns
  #js [upload-modal/icon-column
       upload-modal/name-column
       upload-modal/type-column
       upload-modal/size-column
       upload-modal/upload-status-column
       action-column])

(def font-columns
  #js [upload-modal/icon-column
       upload-modal/name-column
       fonts/weight-or-status-column
       fonts/style-column
       action-column])

(defui new-asset-modal []
  (let [queue (use-subscribe [::db/get-queue])
        modal-open (use-subscribe [::db/modal-open])
        {:keys [asset-type font-family]} (use-subscribe [::db/props])

        active-upload (boolean (upload-modal/queue-first-by-status queue "uploading"))
        [measure-header-ref measure-header] (useMeasure)
        dropzone (useDropzone #js {:onDrop (fn [files]
                                             (rf/dispatch [::db/set-queue files]))})

        font-family-form? (and (= :fonts asset-type)
                               (empty? font-family))
        header-height (.-height measure-header)
        props {:dropzone        dropzone
               :columns         (if (= :fonts asset-type)
                                  font-columns
                                  columns)
               :queue           queue
               :asset-type      asset-type
               ;; Used by e.g. the placeholder component to select the correct texts
               ;; could be refactored away, and correct texts provided here directly.
               :on-cancel       #(rf/dispatch [::db/close])
               :on-start-upload #(rf/dispatch [:assemble.resource.asset/start-upload])}]
    ;; Note: if we allow closing the modal while we have uploads in progress,
    ;; this should be also moved to a place where it is called always.
    (useBeforeUnload active-upload "You have unsaved changes, are you sure?")
    ($ upload-modal/modal-dialog
       {:header-height header-height
        :measure-header-ref measure-header-ref
        :modal-open modal-open
        :on-close #(rf/dispatch [::db/close])
        :parent-nodes (rest (use-subscribe [:assemble.page.assets.file-tree/parent-nodes]))}
       (cond
         font-family-form?
         ($ fonts/font-family-form (assoc props :header-height header-height))

         (seq queue)
         ($ upload-modal/upload-files-list props)

         :else
         ($ upload-modal/upload-area-placeholder-view props)))))
